/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class EIASource extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "EIASource";
}

const servicePlugin = makeServicePlugin({
  Model: EIASource,
  service: feathersClient.service("data-services/eia/sources"),
  idField: "series_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
